import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import {
  getCheapestSelectedPackageOption,
  getCheapestAvailablePackageOption,
  arePricesLoading,
  getFromDurationLabel,
} from 'selectors/offerPage/offerPageSelectors'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import WalledContent from 'components/Common/WalledContent'
import { useIntl } from 'react-intl'

import DesktopRelatedTravelItems from 'components/OfferPage/RelatedTravelItems'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import Group from 'components/utils/Group'
import OfferPageStickyFooter from '../OfferPageStickyFooter'
import { getHotelOfferDisplayedValue } from 'lib/offer/getOfferDisplayPricing'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface Props {
  offer: App.HotelOffer
  onViewPackageOptions: () => void
  cheapestSelectedOption?: App.OfferPackageOptionView
  cheapestOption: App.OfferPackageOptionView
  calendarsLoading?: boolean
  headlessMode: boolean
  durationLabel: string
}

function AlwaysOnAndLMEOfferPageStickyFooter(props: Props) {
  const {
    offer,
    onViewPackageOptions,
    cheapestOption,
    cheapestSelectedOption,
    calendarsLoading,
    headlessMode,
    durationLabel,
  } = props

  const intl = useIntl()
  const dispatch = useOfferPageDispatch()
  const viewOptionsCopy = intl.formatMessage({
    id: 'TUcgskfL171RXVzFZqtn',
    defaultMessage: 'View options',
    description: 'Call to action label in the offer page sticky footer to view package options',
  })

  const onViewOptionsClick = () => {
    dispatch({ type: OfferPageActions.closeFilter })
    onViewPackageOptions()
  }

  const packageView = cheapestSelectedOption ?? cheapestOption
  const hotelPrice = packageView.hotelTotal
  const { shouldShowValue, shouldShowDiscountPercent, highestDiscountPercent } = getHotelOfferDisplayedValue(!!offer.bundledWithFlightsOnly, hotelPrice, cheapestOption.hotelValue, !!offer.shouldDisplayValue)

  return (
    <OfferPageStickyFooter
      visible
      callToActionCopy={viewOptionsCopy}
      onCTAClick={onViewOptionsClick}
      offer={offer}
    >
      {!headlessMode && <DesktopRelatedTravelItems offer={offer} />}
      <WalledContent enforced={offer.walledGarden}>
        <Group direction="vertical">
          <PriceRowPriceCaption>{durationLabel}</PriceRowPriceCaption>
          <PriceRowPrice
            size="S"
            price={packageView.hotelTotal}
            saleUnit={offer.saleUnit}
          />
          {shouldShowValue && shouldShowDiscountPercent && <PriceRowValueDiscountWithCaption
            size="M"
            originalValue={cheapestOption.hotelValue}
            discountPercentage={highestDiscountPercent}
          />}
          <LoadingIndicator visible={calendarsLoading} floating opaque />
        </Group>
      </WalledContent>
    </OfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  cheapestSelectedOption: getCheapestSelectedPackageOption(appState, state),
  cheapestOption: getCheapestAvailablePackageOption(state, appState),
  calendarsLoading: arePricesLoading(appState, state),
  headlessMode: appState.system.headlessMode,
  durationLabel: getFromDurationLabel(state, appState),
}), AlwaysOnAndLMEOfferPageStickyFooter)
